var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRtl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12429_71608",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12429_71608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63255 14.4333L2.19922 12L4.63255 9.56667L5.33255 10.2667L4.09922 11.5H13.7992V12.5H4.09922L5.33255 13.7333L4.63255 14.4333ZM6.36589 9.83333V6.5H6.19922C5.51033 6.5 4.92144 6.25556 4.43255 5.76667C3.94366 5.27778 3.69922 4.68889 3.69922 4C3.69922 3.31111 3.94366 2.72222 4.43255 2.23333C4.92144 1.74444 5.51033 1.5 6.19922 1.5H11.0326V2.5H9.69922V9.83333H8.69922V2.5H7.36589V9.83333H6.36589ZM6.36589 5.5V2.5H6.19922C5.78811 2.5 5.43544 2.64711 5.14122 2.94133C4.84655 3.236 4.69922 3.58889 4.69922 4C4.69922 4.41111 4.84655 4.764 5.14122 5.05867C5.43544 5.35289 5.78811 5.5 6.19922 5.5H6.36589Z",
    fill: "#7D899D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.cd59e5c024e826715b154e3fa74f5659.svg";
export { ForwardRef as ReactComponent };